import { useEffect, useState } from "react";
import "./helpAndSupportDrawer.css";
import { Drawer } from "@mui/material";
import { lazy, Suspense } from "react";
import HelpAndSupportNavBar from "./Component/NavBar/HelpAndSupportNavBar";

// lazy loading for the components

const HELP_PAGES = {
  // <CartConfig /> -- component
  CART_CONFIGURATION: {
    component: lazy(() => import("./Component/CartConfig/CartConfig.js")),
    header: "Help & Support",
    subHeader: " ",
  },
  // <SupportTicket /> -- component
  SUPPORT_TICKET: {
    component: lazy(() => import("./Component/SupportTicket/SupportTicket.js")),
    // header: "Support Ticket",
    // subHeader: "We are here to help you",
  },

  // <CreateTicket /> -- component
  CREATE_TICKET: {
    component: lazy(() => import("./Component/CreateTicket/CreateTicket.js")),
    header: "New Ticket",
    subHeader: " ",
  },

  // <PreviewTicket /> -- component
  PREVIEW_TICKET: {
    component: lazy(() => import("./Component/PreviewTicket/PreviewTicket.js")),
    header: "TICKET",
    subHeader: " ",
  },

  // <CallSupport /> -- component
  CALL_SUPPORT: {
    component: lazy(() => import("./Component/CallSupport/CallSupport.js")),
    header: "Call Support",
    // subHeader: "We're here to help",
  },

  // <KnowledgeBase /> -- compoenent
  KNOWLEDGE_BASE: {
    component: lazy(() => import("./Component/KnowledgeBase/KnowledgeBase.js")),
    header: "Knowledge Base",
    subHeader: " ",
  },

  KNOWLEDGE_BASE_SUB_CATEGORY_LIST: {
    component: lazy(() =>
      import("./Component/KnowledgeBase/Component/KnoledgeCategorySection/KnowledgeSubCategory.js")
    ),
    // header: "",
    // subHeader: "",
  },

  KNOWLEDGE_BASE_PREVIEW: {
    component: lazy(() =>
      import("./Component/KnowledgeBase/Component/KnowledgePreview/KnowledgePreview.js")
    ),
    // header: "",
    // subHeader: "",
  },
};

const HelpAndSupportDrawer = ({ open, onClose }) => {
  // this is used to save the current page and navigate to the back page

  const [pageStack, setPageStack] = useState([{ page: "CART_CONFIGURATION", data: null }]);

  useEffect(() => {
    if (open) {
      setPageStack([{ page: "CART_CONFIGURATION", data: null }]);
    }
  }, [open]);

  //   --------------------for navigate next and back -------------

  // navigate forward
  //  navigate("SUPPORT_TICKET")
  //  navigate("CART_CONFIGURATION")
  // navigate("CREATE_TICKET")
  // navigate("PREVIEW_TICKET")
  // navigate("CALL_SUPPORT")
  // navigate("KNOWLEDGE_BASE")
  // navigate("KNOWLEDGE_BASE_SUB_CATEGORY_LIST")
  // navigate("KNOWLEDGE_BASE_PREVIEW")
  const navigate = (page, data = null) => {
    setPageStack((prev) => [...prev, { page, data }]);
  };

  // go back
  const goBack = () => {
    setPageStack((prev) => prev.slice(0, -1));
  };

  //   define the current page and current component --------------------
  const currentPageObj = pageStack[pageStack?.length - 1];
  const currentPage = currentPageObj?.page;
  const pageData = currentPageObj?.data;

  const CurrentPageConfig = HELP_PAGES[currentPage];

  const CurrentComponent = CurrentPageConfig?.component;
  const header = pageData?.header || CurrentPageConfig?.header;
  const subHeader = pageData?.subHeader || CurrentPageConfig?.subHeader;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      // PaperProps={{ className: "hold-drawer-paper" }}
    >
      <main className="help-support-main-container">
        {/* navbar */}
        <div className="help-support-body-wrapper">
          {header && subHeader && (
            <HelpAndSupportNavBar
              headder={header}
              subHeadder={subHeader}
              canGoBack={pageStack?.length > 1}
              onBack={goBack}
              onClose={onClose}
            />
          )}

          {/* session components */}
          <Suspense fallback={<div>Loading...</div>}>
            <CurrentComponent
              navigate={navigate}
              goBack={goBack}
              onClose={onClose}
              {...(pageData || {})}
            />
          </Suspense>

          {/* footer section */}
        </div>
      </main>
    </Drawer>
  );
};

export default HelpAndSupportDrawer;
